import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';

const resetInvoicingDemoData = async (sessionId: string | null) => {
    return axios.post(
        `${API_URL}/invoices/demo/reset`,
        {},
        {
            headers: {
                Authorization: sessionId,
            },
        },
    );
};

export const useResetInvoicingDemoData = () => {
    const sessionContext = useContext(SessionContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: () => resetInvoicingDemoData(sessionContext?.sessionId ?? null),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['/invoices/feed'] });
            queryClient.invalidateQueries({ queryKey: ['/invoice/detail'] });
            queryClient.invalidateQueries({ queryKey: ['/invoice/activity-logs'] });
        },
        onError: (error) => {
            console.error('Failed to reset invoicing demo data:', error);
        },
    });
};
